

















import { Vue, Component } from 'nuxt-property-decorator';

@Component<TrustPilotBadge>({
  name: 'TrustPilotBadge',
})
export default class TrustPilotBadge extends Vue {
  mounted() {
    if (this.$refs.widget && window.Trustpilot) {
      window.Trustpilot?.loadFromElement(this.$refs.widget, true);
    }
  }
}
